// removed by extract-text-webpack-plugin
module.exports = {"Parallax":"ParallaxImage__Parallax__1jHH6","ParallaxInner":"ParallaxImage__ParallaxInner__KubMM"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/ParallaxImage/ParallaxImage.css
// module id = 367
// module chunks = 0